import React from "react";
import moment from "moment";
import * as Glob from "../../Globale";
import { CampoData, CampoNumero, Tipo, Trad, ValidationResult } from "../../components";
import useReducerOnChange from "../../hooks/ReducerOnChange";
import { Companies } from "../../components/DigitalProductAnalyser/configPensioners";
import { DurationValues, MaxDistraintSum, MinDistraintSum, MaxNetPension, MinNetPension, MonthsNumber } from "./Constants";
import { getInsuranceAge } from "./helpers";

class CDataLoanFormPensioners {
    public DateOfBirth: Date = new Date("2000-01-01");
    public DistraintSum: number = 0;
    public Duration: string = "24";
    public EffectiveDate: Date = new Date(Date.now());
    public Installment: number = 0;
    public NetPension: number = 0;
    public InvalidityPension: boolean = false;
    public DisabilityPension: boolean = false;
}

export const LoanFormPensioners = () => {
    const [FormData, setFormData] = useReducerOnChange<CDataLoanFormPensioners>(new CDataLoanFormPensioners());
    const insuranceAmount = FormData.Installment * parseInt(FormData.Duration);
    const initialAge = moment(FormData.EffectiveDate).diff(FormData.DateOfBirth, "years");
    const isCommitmentThresholdExceeded: boolean = FormData.DistraintSum + FormData.Installment > FormData.NetPension * Companies[0].CoexistencesMaxRatio;
    const insuranceAge = getInsuranceAge(FormData.EffectiveDate, FormData.DateOfBirth);
    const durationYears = parseInt(FormData.Duration) / MonthsNumber.Year;
    const insuranceEndAge = insuranceAge + durationYears;
    const isMaxInstallmentExceeded = FormData.Installment > FormData.NetPension * 0.2;

    const validateInstallmentVal = () => {
        if (isMaxInstallmentExceeded) {
            Glob.InfoModaleWarning(Trad.Trad("LIMITE SUPERIORE SUPERATO"), "Rata Ceduta Non Può essere Nulla o Superiore ad Un Quinto della Pensione Netta Mensile");
        }
    };

    return (
        <div data-sticky-container>
            <div
                data-sticky="true"
                data-margin-top="135"
                data-sticky-class="kt-sticky"
                data-sticky-wrap="true"
                data-sticky-for="1024"
                className="form-group kt-form login-form__group row dashedborder"
            >
                <div className="col-lg-4 offset-lg-4 align-self-center TextCenter kt-padding-t-10 kt-padding-b-15">
                    <img alt="Logo" src="images/companies/logo_metlife.png" width="155" />
                </div>
                <div className="col-lg-4 align-self-center TextCenter">
                    <img alt="Logo" src="images/companies/logo_sgi.png" width="250" />
                </div>
            </div>
            <div className="form-group kt-form login-form__group row dashedborder">
                <div className="col-lg-4">
                    <label>Pensione Netta Mensile</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <CampoNumero
                            Id="NetPension"
                            Name="NetPension"
                            Valore={FormData.NetPension}
                            Minimo={MinNetPension}
                            Massimo={MaxNetPension}
                            OnChange={(e: React.FormEvent<any>) =>
                                setFormData({
                                    Type: "OnChangeFromForm",
                                    Target: e.currentTarget
                                })
                            }
                            OnBlur={validateInstallmentVal}
                            Precisione={2}
                            CSS="form-control kt-input"
                            Icona={"fa " + Glob.ValutaSimbolo}
                        />
                    </div>
                </div>
            </div>
            <div className="form-group kt-form login-form__group row dashedborder">
                <div className="col-lg-4">
                    <label>Rata Ceduta</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <CampoNumero
                            Id="Installment"
                            Name="Installment"
                            Valore={FormData.Installment}
                            Minimo={1}
                            OnChange={(e: React.FormEvent<any>) =>
                                setFormData({
                                    Type: "OnChangeFromForm",
                                    Target: e.currentTarget
                                })
                            }
                            OnBlur={validateInstallmentVal}
                            Precisione={2}
                            CSS="form-control kt-input"
                            Icona={"fa " + Glob.ValutaSimbolo}
                        />
                    </div>
                </div>
            </div>
            <div className="form-group kt-form login-form__group row dashedborder">
                <div className="col-lg-4">
                    <label>Durata Finanziamento</label>
                    <Tipo
                        Dati={DurationValues}
                        Disabilitato={isMaxInstallmentExceeded}
                        Campo="Duration"
                        ID_ChiaveString={FormData.Duration}
                        TradValori={false}
                        OnAggiorna={(e: string, v: string) =>
                            setFormData({
                                Type: "OnChangeFromValue",
                                Name: e,
                                Value: v
                            })
                        }
                        Richiesto
                    />
                </div>
            </div>
            <div className="form-group kt-form login-form__group row dashedborder">
                <div className="col-lg-4">
                    <label>Data Decorrenza</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <div className="form-control">
                            <CampoData
                                ValoreInArrivo={false}
                                Disabilitato={isMaxInstallmentExceeded}
                                Name="EffectiveDate"
                                Id="EffectiveDate"
                                Valore={FormData.EffectiveDate}
                                OnChange={(e: string, v: string) =>
                                    setFormData({
                                        Type: "OnChangeFromValue",
                                        Name: e,
                                        Value: v
                                    })
                                }
                                DataMinima={moment().add(-90, "day").toDate()}
                                DataMassima={moment().add(90, "day").toDate()}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-group kt-form login-form__group row dashedborder">
                <div className="col-lg-4">
                    <label>Capitale da Assicurare</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <CampoNumero
                            Id="InsuranceAmount"
                            Name="InsuranceAmount"
                            Valore={insuranceAmount}
                            OnChange={(e, v) => {}}
                            Precisione={2}
                            CSS="form-control kt-input"
                            Icona={"fa " + Glob.ValutaSimbolo}
                            Disabilitato
                        />
                    </div>
                </div>
                {Companies.map((company: any) => {
                    let message = insuranceAmount > company.InsuranceAmount.MaxValue ? company.InsuranceAmount.Message : "";
                    return <ValidationResult Message={message} />;
                })}
            </div>
            <div className="form-group kt-form login-form__group row dashedborder">
                <div className="col-lg-4">
                    <label>Data di Nascita</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <div className="form-control">
                            <CampoData
                                ValoreInArrivo={false}
                                Name="DateOfBirth"
                                Id="DateOfBirth"
                                Valore={FormData.DateOfBirth}
                                Disabilitato={isMaxInstallmentExceeded}
                                DataMassima={moment().add(-1, "day").toDate()}
                                OnChange={(e: string, v: string) =>
                                    setFormData({
                                        Type: "OnChangeFromValue",
                                        Name: e,
                                        Value: v
                                    })
                                }
                            />
                        </div>
                    </div>
                </div>
                {Companies.map((company: any) => {
                    const { MinAge, MaxAge, MaxAgeInsuranceEnd } = company.DateOfBirth;

                    const messageId = `${insuranceEndAge < MaxAgeInsuranceEnd}_${initialAge < MaxAge}_${insuranceAge > MinAge}`;
                    return <ValidationResult Message={company.DateOfBirth.Messages[messageId]} />;
                })}
            </div>
            <div className="form-group kt-form login-form__group row dashedborder">
                <div className="col-lg-12">
                    <label>Età Inizio Piano</label>
                </div>
                <div className="col-lg-2">
                    <label>Assicurativa</label>
                    <input type="text" className="form-control kt-input" value={insuranceAge} readOnly />
                </div>
                <div className="col-lg-2">
                    <label>Anagrafica</label>
                    <input type="text" className="form-control kt-input" value={initialAge} readOnly />
                </div>
            </div>
            <div className="form-group kt-form login-form__group row dashedborder">
                <div className="col-lg-4">
                    <label>Pignoramenti/Alimenti</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <CampoNumero
                            Id="DistraintSum"
                            Name="DistraintSum"
                            Valore={FormData.DistraintSum}
                            Disabilitato={isMaxInstallmentExceeded}
                            Minimo={MinDistraintSum}
                            Massimo={MaxDistraintSum}
                            OnChange={(e: React.FormEvent<any>) =>
                                setFormData({
                                    Type: "OnChangeFromForm",
                                    Target: e.currentTarget
                                })
                            }
                            Precisione={2}
                            CSS="form-control kt-input"
                            Icona={"fa " + Glob.ValutaSimbolo}
                        />
                    </div>
                </div>
                <ValidationResult
                    Columns={8}
                    Message={
                        isCommitmentThresholdExceeded
                            ? `In Relazione alle Coesistenze attuali del Cedente per un totale di ${Trad.TradParam("{1-I}", [
                                  FormData.DistraintSum
                              ])}, la rata proposta del finanziamento pari ad ${Trad.TradParam("{1-I}", [FormData.Installment])} supera i 2/5  della Pensione Netta pari ad ${Trad.TradParam("{1-I}", [
                                  FormData.NetPension
                              ])}`
                            : ""
                    }
                />
                ;
            </div>
            <div className="form-group kt-form login-form__group row dashedborder">
                <div className="col-lg-4">
                    <label>Il Cedente è titolare di Pensione di Invalidità?</label>
                    <div className="kt-radio-inline inlinea">
                        <label className="kt-radio kt-radio--solid kt-radio--state-success">
                            <input
                                value="True"
                                type="radio"
                                checked={FormData.InvalidityPension}
                                disabled={isMaxInstallmentExceeded}
                                onChange={e => {
                                    setFormData({
                                        Type: "OnChangeFromValue",
                                        Name: "InvalidityPension",
                                        Value: true
                                    });
                                }}
                            />
                            SI<span></span>
                        </label>
                        <label className="kt-radio kt-radio--solid kt-radio--state-success">
                            <input
                                value={"false"}
                                type="radio"
                                checked={!FormData.InvalidityPension}
                                disabled={isMaxInstallmentExceeded}
                                onChange={e => {
                                    setFormData({
                                        Type: "OnChangeFromValue",
                                        Name: "InvalidityPension",
                                        Value: false
                                    });
                                }}
                            />
                            NO<span></span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="form-group kt-form login-form__group row dashedborder">
                <div className="col-lg-4">
                    <label>Il Cedente è titolare di Pensione di Inabilità?</label>
                    <div className="kt-radio-inline inlinea">
                        <label className="kt-radio kt-radio--solid kt-radio--state-success">
                            <input
                                value="True"
                                type="radio"
                                checked={FormData.DisabilityPension}
                                disabled={isMaxInstallmentExceeded}
                                onChange={e => {
                                    setFormData({
                                        Type: "OnChangeFromValue",
                                        Name: "DisabilityPension",
                                        Value: true
                                    });
                                }}
                            />
                            SI<span></span>
                        </label>
                        <label className="kt-radio kt-radio--solid kt-radio--state-success">
                            <input
                                value={"false"}
                                type="radio"
                                checked={!FormData.DisabilityPension}
                                disabled={isMaxInstallmentExceeded}
                                onChange={e => {
                                    setFormData({
                                        Type: "OnChangeFromValue",
                                        Name: "DisabilityPension",
                                        Value: false
                                    });
                                }}
                            />
                            NO<span></span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="form-group kt-form login-form__group row dashedborder">
                <div className="col-lg-4">
                    <label>Documentazione Richiesta</label>
                </div>
                {Companies.map((company: any) => {
                    const messageId = `${FormData.InvalidityPension}_${FormData.DisabilityPension}_${insuranceAmount > company.Documentation.MaxInsuranceAmount}`;
                    return <ValidationResult Message={company.Documentation.Messages[messageId]} />;
                })}
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/DigitalProductAnalyser/LoanFormPensioners.tsx